import React from 'react';
import { Flex, Text } from '@chakra-ui/react';
import useFocusIssueConfig from 'src/hooks/useFocusIssue';

type IProps = {
  value: string;
  submissionContextId: string;
  subtitle?: string;
};

export const FocusIssueSelectDisplay: React.FC<IProps> = ({
  value,
  submissionContextId,
  subtitle
}) => {
  const { selectedFocusIssue } = useFocusIssueConfig(
    submissionContextId,
    value
  );

  const displayValue = selectedFocusIssue?.name || value;

  return (
    <Flex flexDirection={'column'}>
      <Text textStyle={'textBody'}>{displayValue}</Text>
      {subtitle && <Text textStyle="textBody">{subtitle}</Text>}
    </Flex>
  );
};
